/**
 * @file Additional utils types for TS
 */

import { Simplify, Except } from 'type-fest';

/**
 * Similar to TS core util type "Partial",
 * but makes optional values in multidimensional objects
 */
export type DeepPartial<T> = T extends object ? {
    [P in keyof T]?: DeepPartial<T[P]>;
} : T;

export type SetNullable<BaseType, Keys extends keyof BaseType> =
Simplify<
    // Pick just the keys that are readonly from the base type.
    Except<BaseType, Keys> &
    {
        [K in Keys]: BaseType[K] | null;
    }
>;

/**
 * Asserts that the given value is an object and not NULL
 *
 * @param value Anything
 * @returns
 */
export function isObject(value: unknown): value is Record<string, unknown> {
    return typeof value === 'object' && value !== null;
}
